import React from "react";
import AddPrice from "../components/AddPrice";
import useAddPrice from "../hooks/useAddPrice";

export default function AddPriceInterface(props) {
  const {
    price,
    currency,
    priceLabel,
    onPriceChange,
    onCurrencyChange,
    onPriceLabelChange,
    onSave,
  } = useAddPrice(props);

  return (
    <AddPrice
      price={price}
      currency={currency}
      priceLabel={priceLabel}
      onPriceChange={onPriceChange}
      onCurrencyChange={onCurrencyChange}
      onPriceLabelChange={onPriceLabelChange}
      onSave={onSave}
    />
  );
}
